const helpSectionConstants = {
	GET_HELPS: {
		FAILURE : 'GET_HELPS_FAILURE',
		REQUEST : 'GET_HELPS_REQUEST',
		SUCCESS : 'GET_HELPS_SUCCESS'
	},
	GET_ONE_HELP: {
		FAILURE : 'GET_ONE_HELP_FAILURE',
		REQUEST : 'GET_ONE_HELP_REQUEST',
		SUCCESS : 'GET_ONE_HELP_SUCCESS'
	},
	GET_HELP_TAGS: {
		FAILURE : 'GET_HELP_TAGS_FAILURE',
		REQUEST : 'GET_HELP_TAGS_REQUEST',
		SUCCESS : 'GET_HELP_TAGS_SUCCESS'
	},
	UPDATE_HELP_TAG: {
		FAILURE : 'UPDATE_HELP_TAG_FAILURE',
		REQUEST : 'UPDATE_HELP_TAG_REQUEST',
		SUCCESS : 'UPDATE_HELP_TAG_SUCCESS'
	},
	CREATE_HELP_TAG: {
		FAILURE : 'CREATE_HELP_TAG_FAILURE',
		REQUEST : 'CREATE_HELP_TAG_REQUEST',
		SUCCESS : 'CREATE_HELP_TAG_SUCCESS'
	},
	DELETE_HELP_TAG: {
		FAILURE : 'DELETE_HELP_TAG_FAILURE',
		REQUEST : 'DELETE_HELP_TAG_REQUEST',
		SUCCESS : 'DELETE_HELP_TAG_SUCCESS'
	},
	RESTORE_HELP_TAG: {
		FAILURE : 'RESTORE_HELP_TAG_FAILURE',
		REQUEST : 'RESTORE_HELP_TAG_REQUEST',
		SUCCESS : 'RESTORE_HELP_TAG_SUCCESS'
	},
	CREATE_HELP: {
		FAILURE : 'CREATE_HELP_FAILURE',
		REQUEST : 'CREATE_HELP_REQUEST',
		SUCCESS : 'CREATE_HELP_SUCCESS'
	},
	DELETE_HELP: {
		FAILURE : 'DELETE_HELP_FAILURE',
		REQUEST : 'DELETE_HELP_REQUEST',
		SUCCESS : 'DELETE_HELP_SUCCESS'
	},
	UPDATE_HELP: {
		FAILURE : 'UPDATE_HELP_FAILURE',
		REQUEST : 'UPDATE_HELP_REQUEST',
		SUCCESS : 'UPDATE_HELP_SUCCESS'
	},
	RESTORE_HELP: {
		FAILURE : 'RESTORE_HELP_FAILURE',
		REQUEST : 'RESTORE_HELP_REQUEST',
		SUCCESS : 'RESTORE_HELP_SUCCESS'
	},
	CLEAR: 'CLEAR_HELP'
}

export default helpSectionConstants